// Flora Materials: lightbox for sections/image-gallery.liquid.

class ImageGallery extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');

    if (!this.dialog) {
      return;
    }

    this.triggers = Array.from(this.querySelectorAll('[data-gallery-index]'));
    this.image = document.createElement('img');
    this.image.className = 'image-gallery__lightbox-image';
    this.dialog.prepend(this.image);
    this.counter = this.dialog.querySelector('[data-gallery-counter]');
    this.index = 0;
    this._abortController = new AbortController();
    const { signal } = this._abortController;

    this.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-gallery-index]');

      if (trigger && !this.dialog.contains(trigger)) {
        this.open(Number(trigger.dataset.galleryIndex));
      }
    }, { signal });

    this.dialog.addEventListener('click', (event) => {
      const action = event.target.closest('[data-gallery-action]')?.dataset.galleryAction;

      if (action === 'prev') {
        this.show(this.index - 1);
      } else if (action === 'next') {
        this.show(this.index + 1);
      } else if (action === 'close' || event.target === this.dialog) {
        this.dialog.close();
      }
    }, { signal });

    this.dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        this.show(this.index - 1);
      } else if (event.key === 'ArrowRight') {
        this.show(this.index + 1);
      }
    }, { signal });

    this.dialog.addEventListener('close', () => this.triggers[this.index]?.focus(), { signal });
  }

  disconnectedCallback() {
    this._abortController?.abort();
  }

  open(index) {
    this.show(index);
    this.dialog.showModal();
  }

  show(index) {
    const count = this.triggers.length;
    this.index = (index + count) % count;

    const trigger = this.triggers[this.index];
    this.image.src = trigger.dataset.fullSrc;
    this.image.alt = trigger.querySelector('img')?.alt || '';

    if (this.counter) {
      this.counter.textContent = `${this.index + 1} / ${count}`;
    }
  }
}

if (!window.customElements.get('image-gallery')) {
  window.customElements.define('image-gallery', ImageGallery);
}
